import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // While auth is loading, render nothing (avoid flash to login).
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="font-mono text-xs text-white/40 tracking-widest">
          AUTHENTICATING…
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // Password-change enforcement was removed 2026-07-30 per operator
  // directive: the numeric access code is now the permanent primary
  // credential. Password rotations are done manually via env var when
  // the operator asks.

  return children;
}
